module.exports = __webpack_public_path__ + "img/tai-logo.61106dbb.png";